// create history
import Fishx from '@fishx/core'
import { createBrowserHistory as createHistory } from '@fishx/router'

export default function() {
  return createHistory({ basename: '/dscm' })
}
